import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

// TEMPORARY: v3 report validation in progress — the enrollment gate is bypassed so v3 report
// routes are reachable regardless of LifecycleJobCompanies enrollment. Previously this blocked
// direct/deep-link access to a v3 route for a non-enrolled company, redirecting to the legacy
// (v1/v2) equivalent instead (see git history for the enrollment-check version). Restore that
// once validation is done — must keep supplying `data: { reportKey: ReportKey }` in admin.module.ts
// for when it comes back.
@Injectable({
  providedIn: 'root'
})
export class LifecycleReportGuard implements CanActivate {
  async canActivate(): Promise<boolean> {
    return true;
  }
}
